module.exports = __webpack_public_path__ + "img/apple-touch-icon-152x152.d3c2dd8a.png";